const HompageFaqs = [
  {
    question: "1. Who can learn?",
    answer: "No matter your profile – student, connoisseur or enthusiast – if you have an interest in Modern and Contemporary art and want to know more about Indian visual culture practices, this series is for you.\n This platform will take you on a visual, historical and critical journey through Indian Art, its defining moments and key themes and players. You will hear from artists, critics, gallerists and curators – all experts in their field. We follow formats that include films, discussions, close-up readings and walkthroughs."
  },
  {
    question: "2. Where can I browse/purchase available content and sign up for a subscription?",
    answer: "Please visit the ‘Register Page‘ on Art India Education’s website to create an account in order to view the episodes and season. After registering successfully click on the ‘Buy Subscription’ button on your screen and you will be directed to purchase your annual subscription."
  },
  {
    question: "3. How is the subscription priced and structured?",
    answer: "The subscription is priced at INR 999 + 18% GST. As of now we only offer annual subscriptions. The subscription is valid for a year from the date of sign-up. The annual subscription will give each user access to three seasons consisting of four episodes. These will be released periodically throughout the year."
  },
  {
    question: "4. When can I start watching the videos?",
    answer: "Immediate access is granted on signing up for content. All new releases will be updated on the website and announced via email and social media. All released content is accessible throughout the duration of the subscription."
  },
  {
    question: "5. Can I download a video and watch it offline on a mobile phone/desktop/laptop/iPad or similar devices?",
    answer: "You can only watch the videos online on the website – through your subscription. You may view the videos from a device you have logged in from."
  },
  {
    question: "6. Whom should I contact with further questions?",
    answer: "Please send all your questions to education@artindiamag.com"
  },
];
export default HompageFaqs;